import React, { useEffect, useRef, useState } from "react";

const COLORS = ["#4ade80", "#22c55e", "#fbbf24", "#f97316", "#60a5fa", "#e879f9", "#ffffff", "#34d399", "#fb923c"];

function spawnConfetti(count) {
  for (let i = 0; i < count; i++) {
    setTimeout(() => {
      const el = document.createElement("span");
      el.className = "confetti-piece";
      const color = COLORS[Math.floor(Math.random() * COLORS.length)];
      const duration = 2.2 + Math.random() * 2.2;
      el.style.cssText = [
        `left:${Math.random() * 100}vw`,
        `background:${color}`,
        `width:${7 + Math.random() * 7}px`,
        `height:${10 + Math.random() * 8}px`,
        `animation-duration:${duration}s`,
        "animation-delay:0s",
      ].join(";");
      document.body.appendChild(el);
      setTimeout(() => el.remove(), (duration + 0.1) * 1000);
    }, i * 28);
  }
}

// Auto-shows shortly after load with confetti, auto-dismisses ~5.8s later.
// Clicking anywhere scrolls to the Starter pricing card.
export default function OfferPopup({ onGoToStarter }) {
  const [visible, setVisible] = useState(false);
  const [gone, setGone] = useState(false);
  const clicked = useRef(false);

  useEffect(() => {
    const showT = setTimeout(() => {
      setVisible(true);
      spawnConfetti(70);
    }, 400);
    const hideT = setTimeout(() => setVisible(false), 400 + 5800);
    const removeT = setTimeout(() => setGone(true), 400 + 5800 + 450);
    return () => { clearTimeout(showT); clearTimeout(hideT); clearTimeout(removeT); };
  }, []);

  if (gone) return null;

  return (
    <div
      id="offer-popup-overlay"
      className={visible ? "visible" : ""}
      role="dialog"
      aria-modal="true"
      aria-label="Annual Special Offer"
      onClick={() => {
        if (clicked.current) return;
        clicked.current = true;
        setVisible(false);
        setTimeout(() => setGone(true), 450);
        onGoToStarter?.();
      }}
    >
      <div id="offer-popup-card">
        <span className="offer-popup-fire">🎉</span>
        <span className="offer-popup-label">Limited Time</span>
        <h2 className="offer-popup-title">Annual <em>Special Offer</em></h2>
        <p className="offer-popup-sub">Live July – September · Lock in your release price now before it's gone.</p>
        <div className="offer-popup-deal">
          <span className="offer-popup-chip">🔥 20% OFF Artist Pro</span>
          <span className="offer-popup-chip">⚡ 40% OFF Starter</span>
          <span className="offer-popup-chip">💰 Save up to ₹360</span>
        </div>
        <div className="offer-popup-progress"><div className="offer-popup-progress-bar" /></div>
        <p className="offer-popup-dismiss">Auto-closing in a moment…</p>
      </div>
    </div>
  );
}
